import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';

interface FieldProps extends FormlyFieldProps {
  addonLeft: string;
  addonRight: string;
  decimalFormat: string;
  modelPaths: string[];
}

@Component({
    selector: 'lockton-apps-summary-type',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<div class="p-2 bg-grayLightLow rounded"
      >{{ props.label }}:
      <span class="ms-2 bold mat-h4">
        <span class="me-_5" *ngIf="props.addonLeft">{{ props.addonLeft }}</span
        >{{ formControl.value || 0 | number : props.decimalFormat || '1.2'
        }}<span class="ms-_5" *ngIf="props.addonRight">{{
          props.addonRight
        }}</span></span
      ></div
    >
    <mat-error *ngIf="field.formControl.invalid">
      <formly-validation-message [field]="field"></formly-validation-message>
    </mat-error> `,
    standalone: false
})
export class SummaryTypeComponent extends FieldType<
  FieldTypeConfig<FieldProps>
> {}
